const initialState = {
  data: [],
  success: false,
  error: false,
};

export const postByIdRequest = (namespace) => (state = initialState, action) => {
  switch (action.type) {
    case `${namespace}/POST_BY_ID_REQUEST_REQUEST`: {
      return initialState;
    }
    case `${namespace}/POST_BY_ID_REQUEST_SUCCESS`: {
      return { ...state, data: action.data, success: true };
    }
    case `${namespace}/POST_BY_ID_REQUEST_FAILURE`: {
      return { ...state, data: action.error, success: true, error: true };
    }
    default:
      return state;
  }
};
